<template>
    <h2>Others</h2>
    <p>&lt;kbd&gt;: <kbd>Ctrl+S</kbd></p>
    <p>&lt;mark&gt;: <mark>Highlight</mark></p>
    <p>&lt;code&gt;: <code>console.log</code></p>
    <p>&lt;del&gt;: <del>Test</del></p>
    <p>&lt;ins&gt;: <ins>Test</ins></p>
</template>
